import { Box, Button, MenuItem, Stack, TextField } from '@mui/material';
import { FormHook } from '../hook/useForm';
import { ProductsFilters } from '../models/interfaces';
import { FilterWrapper } from '../shared/all.styles';
import { Typography } from '../shared/typography';
import { useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';
import { useEffect, useState } from 'react';

const FILTER_STORE_KEY = 'products';

interface Props {
  clearFilters: () => void;
  formProps: FormHook<ProductsFilters>;
  hideStatus?: boolean;
  defaultFilters: ProductsFilters;
}

const ProductFilters = ({
  clearFilters,
  formProps: { bindTextField, submit, form, setValue },
}: Props) => {
  const { t } = useTranslation();

  const [cookie, setCookie] = useCookies([`fltrs-${FILTER_STORE_KEY}`]);

  const [hasReviwString, setHasReviewString] = useState<string>('all');

  const handleSubmit = () => {
    setCookie(`fltrs-${FILTER_STORE_KEY}`, form);
    submit();
  };

  const handleClearFilters = () => {
     setCookie(`fltrs-${FILTER_STORE_KEY}`, {});
    clearFilters();
  };

  useEffect(() => {
    if (cookie[`fltrs-${FILTER_STORE_KEY}`]) {
      form = cookie[`fltrs-${FILTER_STORE_KEY}`];
      const hasReview = cookie[`fltrs-${FILTER_STORE_KEY}`]?.to_review;
      switch (hasReview) {
        case true:
          setHasReviewString('yes');
          break;
        case false:
          setHasReviewString('no');
          break;
        default:
          setHasReviewString('all');
          break;
      }
    }
  }, [cookie]);

  return (
    <>
      <FilterWrapper grayBackground>
        <Stack direction={'row'} spacing={3} alignItems={'center'}>
          <Typography variant="subtitle1">{t('cluster.filters')}</Typography>
          <Box
            sx={{
              width: '1px',
              backgroundColor: 'gray',
              height: '40px',
              display: 'block',
              opacity: 0.8,
            }}
          />
          <Stack spacing={2} width="100%">
            {/* Prima riga */}
            <Stack direction="row" spacing={3} alignItems="center" width="100%">
              <TextField
                {...bindTextField({ field: 'cluster_id' })}
                label={t('cluster.id')}
                fullWidth
                sx={{ maxWidth: '40%', borderRadius: '30px' }}
              />
              <TextField
                {...bindTextField({ field: 'id_gestionale' })}
                label={t('product.managementId')}
                fullWidth
                sx={{ maxWidth: '40%', borderRadius: '30px' }}
              />
              <TextField
                {...bindTextField({ field: 'id_prodotto' })}
                label={t('product.productId')}
                fullWidth
                sx={{ maxWidth: '40%', borderRadius: '30px' }}
              />
              <TextField
                {...bindTextField({ field: 'nome_fornitore' })}
                label={t('product.supplierName')}
                fullWidth
                sx={{ maxWidth: '40%', borderRadius: '30px' }}
              />
              <TextField
                label={t('cluster.toReview')}
                fullWidth
                sx={{ maxWidth: '40%', borderRadius: '30px' }}
                value={hasReviwString}
                select
                onChange={(e) => {
                  const val = e.target.value;
                  switch (val) {
                    case 'yes':
                      setValue({ field: 'to_review', value: true });
                      break;
                    case 'no':
                      setValue({ field: 'to_review', value: false });
                      break;
                    case 'all':
                      setValue({ field: 'to_review', value: undefined });
                      break;
                  }
                  setHasReviewString(val);
                }}
              >
                <MenuItem key={'yes'} value={'yes'}>
                  <Typography truncate>{t('info.yes')}</Typography>
                </MenuItem>
                <MenuItem key={'no'} value={'no'}>
                  <Typography truncate>{t('info.no')}</Typography>
                </MenuItem>
                <MenuItem key={'all'} value={'all'}>
                  <Typography truncate>{t('info.all')}</Typography>
                </MenuItem>
              </TextField>
            </Stack>

            {/* Seconda riga */}
            <Stack direction="row" spacing={3} alignItems="center" width="100%">
              <TextField
                {...bindTextField({ field: 'id_fornitore' })}
                label={t('product.supplierId')}
                fullWidth
                sx={{ maxWidth: '40%', borderRadius: '30px' }}
              />
              <TextField
                {...bindTextField({ field: 'nome_prodotto' })}
                label={t('product.productName')}
                fullWidth
                sx={{ maxWidth: '40%', borderRadius: '30px' }}
              />
              <TextField
                {...bindTextField({ field: 'ref_produttore' })}
                label={t('product.manufacturerRef')}
                fullWidth
                sx={{ maxWidth: '40%', borderRadius: '30px' }}
              />
              <TextField
                {...bindTextField({ field: 'codice_fornitore' })}
                label={t('product.supplierCode')}
                fullWidth
                sx={{ maxWidth: '40%', borderRadius: '30px' }}
              />
              <TextField
                {...bindTextField({ field: 'rdm' })}
                label={t('product.rdm')}
                fullWidth
                sx={{ maxWidth: '40%', borderRadius: '30px' }}
              />
            </Stack>
          </Stack>
          <Stack direction={'row'}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleClearFilters}
              sx={{ mr: '30px', whiteSpace: 'nowrap' }}
            >
              {t('actions.clearFilters')}
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              {t('actions.search')}
            </Button>
          </Stack>
        </Stack>
      </FilterWrapper>
    </>
  );
};

export default ProductFilters;
